import { render } from "./UserPayroll.vue?vue&type=template&id=17d4af1c&ts=true"
import script from "./UserPayroll.vue?vue&type=script&lang=ts"
export * from "./UserPayroll.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__